// Toggle Page Overflow / Constraints
import $ from 'jquery';

$(function(){
  function toggleConstrainPage () {
      var $bodyAndHtml = $("html, body");
      var constrainClass = "page-constrain";
      if(!$bodyAndHtml.hasClass(constrainClass)) {
          $bodyAndHtml.addClass(constrainClass);
      } else {
          $bodyAndHtml.removeClass(constrainClass);
      }
  }
  function removeConstrainPage () {
      var $bodyAndHtml = $("html, body");
      var constrainClass = "page-constrain";
      $bodyAndHtml.removeClass(constrainClass);
  }
  $(".js-constrain-page").on("click", toggleConstrainPage);
  $(document).on("toggleConstrainPage", toggleConstrainPage)
  $(document).on("removeConstrainPage", removeConstrainPage)
});



// WEBPACK FOOTER //
// ./src/scripts/modules/page-constrain.js